export default __webpack_public_path__ + "static/img/matteo_ward_2.d4e147e.jpg";